import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';

interface AdCardProps {
  label?: string;
  headline: string;
  subtext: string;
  ctaText: string;
  ctaHref: string;
  image?: string;
  imageAlt?: string;
}

export default function AdCard({
  label = 'SPONSORED',
  headline,
  subtext,
  ctaText,
  ctaHref,
  image,
  imageAlt = 'Sponsored advertisement',
}: AdCardProps) {
  return (
    <div className="ad-card p-4 rounded-lg">
      <p className="text-xs font-700 uppercase tracking-widest text-muted-foreground mb-3">
        {label}
      </p>
      {image && (
        <div className="relative rounded-md overflow-hidden mb-3" style={{ aspectRatio: '16/9' }}>
          <AppImage
            src={image}
            alt={imageAlt}
            fill
            sizes="300px"
            className="object-cover"
          />
        </div>
      )}
      <h4 className="text-sm font-700 text-foreground leading-snug">{headline}</h4>
      <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{subtext}</p>
      <Link
        href={ctaHref}
        className="mt-3 inline-flex items-center text-xs font-700 text-primary hover:text-primary-dark transition-colors uppercase tracking-wide"
      >
        {ctaText} →
      </Link>
    </div>
  );
}